










import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";

@Component
export default class Commingsoon extends mixins(AxiosMixin) {}
